import { FilterUsers } from 'src/models/filter';

import { Callback } from 'src/util/query/models/Callback';

import { InboxDesktopAccessUsersStoreContract } from '../interfaces';

export class GetAllDesktopAccessUsersForTheUserCallBack extends Callback<Array<FilterUsers>> {
	public constructor(private readonly store: InboxDesktopAccessUsersStoreContract) {
		super();
	}

	failureCallbackFunction = (failureResponse: unknown): void => {
		this.logFailureResponse(failureResponse);
		this.store.setDesktopAccessUsers([]);
	};

	successCallbackFunction = (successResponse: Array<FilterUsers>): void => {
		this.store.setDesktopAccessUsers(successResponse);
	};
}
